<template>
    <div class="chat-reverst-list">
        <div class="padding-div"></div>
        <div class="chat-reverst-ul">
            <div class="seemore" :class="isFixed?'seemore-fixed':''">
                <div class="seemore-btn">
                    <div @click="seemore">{{multyLang&&multyLang['查看更多']?multyLang['查看更多'][currentTranslateCode]:'see more'}}
                        </div>
                </div>
<!--              <i class="el-icon-close" @click="closeChatList"></i>-->
              <i class="hz-icon-close_icon el-icon-close" @click="closeChatList"></i>
            </div>
            <ul>
                <template v-for="(item,index) in noSeeMsgList">
                    <li v-if="item.flow=='in'"
                        :class="noSeeMsgList[index+1]&&item.flow!=(noSeeMsgList[index+1].flow)||(index==noSeeMsgList.length-1 && noSeeMsgList[noSeeMsgList.length-1].flow=='in')?'islast':''"
                        class="other chat-reverst-item">
                        <template>
                            <img class="other-img avator"
                                 v-if="noSeeMsgList[index+1]&&item.flow!=(noSeeMsgList[index+1].flow)||(index==noSeeMsgList.length-1 && noSeeMsgList[noSeeMsgList.length-1].flow=='in')"
                                 :src="avatorSrc" alt="">
                            <div class="other-img avator" v-else></div>
                        </template>
                        <span class="other-text" v-if="item.type=='text'">
                            <span v-html="item.text.replace(/(\r\n|\n|\r)/g, '<br />')"></span>
                         </span>

                        <span class="other-text" v-if="item.type=='customtext'">
                           <template v-if="multyLang&&multyLang[item.text]">
                                 <span  v-html="multyLang[item.text][currentTranslateCode].replace(/(\r\n|\n|\r)/g, '<br />')"></span>
                            </template>
                            <template v-else>
                                <span  v-html="item.text.replace(/(\r\n|\n|\r)/g, '<br />')"></span>
                            </template>
                         </span>
                        <p class="zanicon-left" v-if="item.type=='custom'&&item.content.type=='custom'">
                            <span class="hz-icon-zan icon-zan other-hover"> </span>
                            <!--<span class=" icon other-hover">&#xe614; </span>-->
                        </p>
                        <div class="other-uploadimg" style="margin-bottom: 16px" v-if="item.type=='image'">
                            <img :src="item.file.url" @load="calcHeight">
                        </div>
                        <div class="other-uploadimg" style="margin-bottom: 16px" v-if="item.type=='custom'&&item.content.type=='image'">
                            <img :src="item.content.fileUrl" @load="calcHeight">
                        </div>
                        <!--<span class="other-text" v-if="item.type=='file'">-->
                            <!--<a :href="item.file.url">{{item.file.name}}</a>-->
                         <!--</span>-->
                        <span class="other-uploadimg other-hover" v-if="item.type=='file'">
                             <chat-fiel-msg :fileData="item.file">
                             </chat-fiel-msg>
                        </span>
                        <span class="other-uploadimg other-hover" v-if="item.type=='custom'&&item.content.type=='file'">
                             <chat-fiel-msg :fileData="item.content">
                             </chat-fiel-msg>
                        </span>

                    </li>
                    <li v-if="item.flow=='out'" class="mine chat-reverst-item">
                        <span class="mine-text" v-if="item.type=='text'">
                            <span v-html="item.text"></span>
                        </span>
                        <p class="zanicon-right" v-if="item.type=='custom'">
                            <span class="hz-icon-zan other-hover"> </span>
                        </p>
                        <div class="mine-uploadimg" v-if="item.type=='image'">
                            <img class="" :src="item.file.url" @load="calcHeight">
                        </div>
                        <span class="mine-text" v-if="item.type=='file'">
                            <a :href="item.file.url">{{item.file.name}}</a>
                         </span>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    import ChatItem from "@/components/chatItem";
    import {store} from "../store";
    import ChatFielMsg from "./chatFileMsg";
    import {defaultImg} from "../config/env";

    export default {
        name: 'chatSimpleList',
        components: {ChatFielMsg, ChatItem},
        props: {
            avatorSrc: {
                type: String,
                default: ''
            }
        },
        computed: {
            noSeeMsgList() {
                this.$nextTick(() => {
                    this.calcHeight();
                })
                return store.noSeeList
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            },
            multyLang(){
                return store.multyLang
            },

        },
        data() {
            return {
                isFixed: false,
                headimg: defaultImg,
            }
        },
        mounted() {

            this.$nextTick(() => {
                this.calcHeight();
            })

        },
        methods: {
            calcHeight() {
                let totalHeight = document.querySelector('.chat-reverst-list').clientHeight;
                let ulELe = document.querySelector('.chat-reverst-ul')
                let ulHeight = ulELe.clientHeight;
                let paddingDivEle = document.querySelector('.padding-div');
                if (ulHeight < totalHeight - 50) {
                    this.isFixed = false;
                } else {
                    this.isFixed = true;
                }

                if (ulHeight < totalHeight) {
                    paddingDivEle.style.height = totalHeight - ulHeight - 20 + 'px'

                } else {
                    paddingDivEle.style.height = 0 + 'px';
                    ulELe.scrollTop = ulELe.scrollHeight;

                }
            },
            closeChatList() {
                this.$emit('closeReverseList')

            },
            seemore() {
                this.$emit('seemore')
            }
        }
    }
</script>

<style lang="scss" scoped>
    #hz_chat_app{
        .chat-reverst-list {
            height: 100%;
            height: calc(100%);
            position: relative;
        }
        .padding-div {
            height: 100%;
            transition: 0.28s;

        }

        .chat-reverst-ul {
            overflow-y: hidden;
            max-height: 100%;
            pointer-events: auto;
            overflow-x: hidden;
        }

        .chat-reverst-item {
            margin-bottom: 16px;
        }

        .chat-reverst-item.islast .other-text:after {
            position: absolute;
            left: -10px;
            bottom: 0px;
            content: '';
            width: 0px;
            height: 0px;
            border-color: #fff transparent;
            border-width: 0px 0px 10px 10px;
            border-style: solid;
        }
        .hz-icon-zan{
            padding:0px 6px 6px;
            background:rgba(50,50,50,0.3);
            border-radius: 8px;
            font-size: 40px;
            color: #0084FF;
            height: 40px;
            width: 40px;
            margin-left: 15px;
            line-height: 40px;
        }
        .seemore {
            height: 50px;
            width: 97%;
            margin: 0 auto;
            color: #fff;
            position: relative;
            visibility: hidden;
            padding-top: 10px;
        }

        .chat-reverst-ul:hover .seemore {
            visibility: visible;
        }

        .seemore-btn {
            position: absolute;
            width: 100%;
            text-align: center;
            height: 40px;
            font-size: 12px;
        }

        .seemore-btn div {
            padding: 8px 13px;
            display: inline-block;
            background: #67788F;
            border-radius: 50px;
            cursor: pointer;

        }

        .seemore .el-icon-close {
            background: #67788F;
            color:#fff;
            border-radius: 50%;
            font-size: 16px;
            padding: 8px;
            float: right;
            position: absolute;
            top: 10px;
            right: 0;
            cursor: pointer;
        }

        .seemore-fixed {
            position: absolute;
            top: -30px;
            z-index: 9;

        }

    }
</style>
